import React from "react";
import LoadingSpinner from "../loadingSpinner/LoadingSpinner";

import "./button.scss";

/**
 * Native button wrapped to enable customization with bootstrap sizes and variants
 * @param {{
 * children: JSX.Element,
 * size: "sm" | "lg",
 * variant: "primary" | "secondary" | "outline-primary" | "outline-secondary",
 * type: "button" | "submit",
 * onClick: Function,
 * disabled: boolean,
 * fullWidth: boolean,
 * isLoading: boolean
 * }} props
 * @returns {React.FunctionComponent}
 */
export default function Button({
    type = "button",
    disabled = false,
    children = "Button",
    size = "",
    variant = "primary",
    fullWidth = true,
    isLoading = false,
    onClick,
    ...rest
}) {
    const getButtonClassName = () => {
        const btnClasses = ["", "", ""];

        if (size && typeof size === "string") {
            btnClasses[0] = `btn-${size}`;
        }
        if (typeof variant === "string") {
            btnClasses[1] = `btn-${variant}`;
        }
        if (fullWidth) {
            btnClasses[2] = "w-100";
        }
        return `btn ${btnClasses.join(" ")}`;
    };

    const handleClick = () => {
        if (onClick) {
            onClick();
        }
    };

    return (
        <button
            {...rest}
            type={type}
            className={getButtonClassName()}
            disabled={disabled}
            onClick={handleClick}
            aria-label="button"
        >
            {isLoading ? <LoadingSpinner /> : children}
        </button>
    );
}
